import { Reveal } from "../components/Reveal";
import useSeo from "../lib/useSeo";
import { ABOUT, IMAGES } from "../lib/content";

export default function About() {
  useSeo({
    title: "About Us",
    description: ABOUT.intro,
    path: "/about",
  });

  return (
    <>
      <section className="px-6 pt-40 pb-16 lg:px-10 lg:pt-48">
        <div className="mx-auto max-w-7xl">
          <Reveal>
            <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-gold">About IntoLaw</p>
            <h1 className="max-w-4xl font-display text-5xl font-semibold leading-[0.98] tracking-tight text-navy sm:text-6xl lg:text-7xl">
              Bridging complex law and everyday realities.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="px-6 pb-24 lg:px-10">
        <div className="mx-auto grid max-w-7xl gap-14 lg:grid-cols-12 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl shadow-[0_20px_50px_rgba(10,17,40,0.15)]">
              <img
                src={IMAGES.about}
                alt="Experienced legal consultant"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>
          <div className="lg:col-span-7">
            <Reveal>
              <p className="font-display text-3xl font-medium leading-snug text-navy lg:text-4xl">
                {ABOUT.intro}
              </p>
            </Reveal>
            <div className="mt-8 space-y-6 text-base leading-relaxed text-slate-600 lg:text-lg">
              {ABOUT.paragraphs.map((p, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <p>{p}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="bg-navy grain px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-gold">Our Vision</p>
            <p className="font-display text-3xl font-medium italic leading-snug text-white lg:text-4xl">
              “{ABOUT.vision}”
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-gold">Our Mission</p>
            <p className="font-display text-3xl font-medium italic leading-snug text-white lg:text-4xl">
              “{ABOUT.mission}”
            </p>
          </Reveal>
        </div>
      </section>

      {/* Regulatory disclaimer */}
      <section className="px-6 py-24 lg:px-10">
        <Reveal className="mx-auto max-w-3xl rounded-2xl border border-black/10 bg-white p-8 lg:p-12">
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-slate-400">Regulatory Disclaimer</p>
          <ul className="space-y-3 text-slate-600">
            {ABOUT.disclaimer.map((line, i) => (
              <li key={i} className="flex gap-3">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </section>
    </>
  );
}
